"use client";

import NextLink from "next/link";
import React from "react";
import { NavigateButton } from "../NavigateButton";
import { useIsWebview } from "../WebviewContext/hooks";
import styles from "./styles.module.scss";
import type { ItemSkiArea } from "./types";

export const SkiAreaLinkItem: React.FC<ItemSkiArea> = ({
    name,
    id,
    link,
    country,
    distance,
    isSponsored,
}) => {
    const isWebview = useIsWebview();

    return (
        <div className={styles.locationInner} key={id}>
            {isWebview ? (
                <NavigateButton
                    url={link}
                    skiAreaSponsoring={{ isSponsored }}
                    className={styles.locationInnerButton}
                >
                    <SubTree
                        country={country}
                        distance={distance}
                        name={name}
                    />
                </NavigateButton>
            ) : (
                <NextLink
                    href={link}
                    data-label={`snowLink_textLink_${name}`}
                    aria-label={`Wetter im Skigebiet ${name}`}
                    className={styles.locationLink}
                >
                    <SubTree
                        country={country}
                        distance={distance}
                        name={name}
                    />
                </NextLink>
            )}
        </div>
    );
};

const SubTree: React.FC<Pick<ItemSkiArea, "distance" | "country" | "name">> = ({
    distance,
    country,
    name,
}) => {
    return (
        <div className={styles.locationCnt}>
            <div className={styles.colText}>{country}</div>
            <div className={styles.colTextBold}>{name}</div>
            {distance !== null ? (
                <div className={styles.colDistance}>{distance}</div>
            ) : null}
            <span className="icon-dropdown" />
        </div>
    );
};
